import { computed } from "vue";
import { useMonitorSize } from "./monitor_size";

export function usePhotoEditor() {
  const { isSmallTablet } = useMonitorSize();
  const isNewEditorEnabled = computed(() => !isSmallTablet.value);

  return {
    isNewEditorEnabled,
  };
}
